// extracted by mini-css-extract-plugin
export default {"wrapper":"warning_wrapper__aYoyW","text":"warning_text__zWv0E","checkboxBlock":"warning_checkboxBlock__9JVA4","opacity-transition":"warning_opacity-transition__3FQ95"};